import { render } from "./PaginatorPages.vue?vue&type=template&id=5d5f774a&ts=true"
import script from "./PaginatorPages.vue?vue&type=script&lang=ts"
export * from "./PaginatorPages.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__